<template xmlns:v-on="http://www.w3.org/1999/xhtml">
  <div class="row-col">

    <a 
      data-dismiss="modal" 
      class="pull-right text-muted text-lg p-a-sm m-r-sm">×</a>
    <div class="p-a b-b">
      <span class="h5 text-capitalize">{{ tagExists(tag.id) ? 'Update' : 'Create' }} {{ trans('general.tag') }}</span>
    </div>

    <div class="row-row">
      <div class="row-body">
        <div class="row-inner">
          <div class="p-a">
          
            <div 
              :class="{'invalid':errors.has('name')}" 
              class="md-form-group">
              <input 
                v-validate="'required'" 
                :disabled="loading" 
                v-model="tag.name" 
                type="text" 
                name="name" 
                class="md-input" 
                placeholder="Required">
              <label>Name</label>
              <span 
                v-show="errors.has('name')" 
                class="form-error-msg">{{ errors.first('name') }}</span>
            </div>

            <div
              :class="{'invalid':errors.has('code')}" 
              class="md-form-group">
              <input
                v-validate="'required'" 
                :disabled="loading"
                v-model="tag.code"
                type="text"
                name="code"
                class="md-input"
                placeholder="Required">
              <label>Code</label>
              <span 
                v-show="errors.has('code')" 
                class="form-error-msg">{{ errors.first('code') }}</span>
            </div>

            <div 
              :class="{'invalid':errors.has('description')}" 
              class="md-form-group">
              <input 
                :disabled="loading" 
                v-model="tag.description" 
                type="text" 
                name="description" 
                class="md-input">
              <label>Description</label>
              <span 
                v-show="errors.has('description')" 
                class="form-error-msg">{{ errors.first('description') }}</span>
            </div>

            <div 
              v-show="isRequiredTagInput"
              :class="{'invalid':errors.has('parent')}"
              class="md-form-group">
              <label class="typo__label multiselect-label">{{ trans('tag.parent_tag') }}</label>
              <multiselect 
                v-validate="'required'" 
                id="ajaxTag" 
                v-model="tag.parent"
                :options="tags" 
                :loading="ajaxTagLoading"
                :custom-label="tagOptionsLabel"
                name="parent"
                placeholder="Type to search" 
                label="name"
                track-by="id" 
                @search-change="loadTags"/>
              <span 
                v-show="errors.has('parent')" 
                class="form-error-msg">{{ errors.first('parent') }}</span>
            </div>

            <div class="form-group p-b-sm">
              <a 
                data-dismiss="modal" 
                class="pull-right m-r-sm">{{ tag.products.length }} products selected</a>
              <div class="">
                <span class="typo__label multiselect-label">Product</span>
              </div>
              <div class="p-t-sm">
                <button 
                  class="btn btn-sm btn-block white"
                  data-toggle="modal" 
                  data-target="#m-a-a"
                  ui-toggle-class="fade-up-big" 
                  ui-target="#animate" 
                  @click="show_product_list()">Select products</button>
              </div>             
            </div>

            <div class="form-group p-b-sm">
              <modifier-selector v-model="tag.modifier_sets"/>
            </div>

            <div class="form-group">
              <label>Options</label>
              <div class="form-group">
                <p>
                  <label class="md-switch">
                    <input 
                      :disabled="loading" 
                      v-model="tag.hidden_tag" 
                      type="checkbox" 
                      class="has-value">
                    <i class="indigo"/>
                    {{ trans('tag.hide_tag') }}
                  </label>
                </p>
                <p>
                  <small>{{ trans('tag.the_product_assigned_to_this_tag_will_hidden_from_central_and_waiter') }}.</small>
                </p>
              </div>
              <div class="form-group">
                <p>
                  <label class="md-switch">
                    <input 
                      :disabled="loading" 
                      v-model="tag.hidden_products" 
                      type="checkbox" 
                      class="has-value">
                    <i class="indigo"/>
                    Hide products
                  </label>
                </p>
                <p>
                  <small>{{ trans('tag.the_product_assigned_to_this_tag_will_hidden_from_central_and_waiter') }}.</small>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row no-gutter b-t">
      <div class="col-md-5">
        <div class="p-a text-left">
          <label
            v-if="!tagExists(tag.id)"
            class="md-switch">
            <input
              v-model="toggle"
              type="checkbox">
            <i class="indigo"/> Keep form open
          </label>
        </div>
      </div>
      <div class="col-md-7">
        <div class="p-a">
          <div class="text-right">
            <button 
              :disabled="loading" 
              class="btn btn-fw white"
              data-dismiss="modal">Cancel</button>
            <button 
              :disabled="loading || !canManageItems" 
              class="btn btn-fw primary"
              @click="submit()">Save</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Auth from '@js/plugins/auth';
import ModifierSelector from '../item/modifier-selector';

export default {
    components: {
        ModifierSelector,
    },

    props: {
        tag: {
            type: Object,
            required: true,
        },

        isRequiredTagInput: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            toggle: false,
            ajaxTagLoading: false,
            multiselect_query_limit: 30,
            ajaxProductLoading: false,
            api_item_select: Laroute.route('franchise.vue.products'),
            api_tag_select: Laroute.route('franchise.vue.tags'),
            items: [],
            tags: [],
            loading: false,
        };
    },

    computed: {
        canManageItems() {
            return Auth.hasAnyPermission(
                'franchise_manage_items',
                'franchise_manage_tags',
            );
        },
    },

    watch: {
        toggle(data) {
            localStorage.setItem('toggle', data);
        },
    },

    mounted() {
        var that = this;
        this.loadProducts(null);
        this.loadTags(null);

        $('#tag-popup').on('hidden.bs.modal', function(e) {
            that.errors.clear();
        });

        if (localStorage.getItem('toggle')) {
            this.toggle = JSON.parse(localStorage.getItem('toggle'));
        }
    },

    methods: {
        submit() {
            var that = this;
            this.loading = true;

            let products = this.tag.products.map(function(obj) {
                return obj.id;
            });

            let newParentId =
                this.tag.parent == null ? null : this.tag.parent.id;

            if (!this.isRequiredTagInput) {
                newParentId = this.tag.parent_id;
            }

            let data = {
                name: this.tag.name,
                parent_id: newParentId,
                code: this.tag.code,
                description: this.tag.description,
                products: products,
                modifier_sets: this.tag.modifier_sets.map(obj => obj.id),
                hidden_tag: this.tag.hidden_tag,
                hidden_products: this.tag.hidden_products,
                type: this.tag.type,
            };

            this.$validator.validateAll().then(result => {
                if (result) {
                    that.$http.post(that.getTagApi(that.tag.id), data).then(
                        response => {
                            if (response.status == '200') {
                                if (!that.tagExists(that.tag.id)) {
                                    that.$parent.init_tag();
                                }

                                if (!that.toggle) {
                                    $('#tag-popup').modal('hide');
                                }

                                this.$bus.$emit('category_tree::rebuild');
                                this.$bus.$emit('table_item::reload');

                                let msg =
                                    'Tag successfully ' +
                                    (!that.tagExists(that.tag.id)
                                        ? 'created'
                                        : 'updated');
                                toastr.success(msg);

                                this.$emit('tag-saved');
                            }

                            that.loading = false;
                        },
                        error => {
                            toastr.error(error.statusText);
                            that.loading = false;
                        },
                    );
                } else {
                    that.loading = false;
                }
            });
        },

        tagExists(id) {
            return id != 0 && id != undefined;
        },

        getTagApi(id) {
            if (this.tagExists(id)) {
                return Laroute.route('franchise.inventory.tags.update', {
                    id: id,
                });
            } else {
                return Laroute.route('franchise.inventory.tags.store');
            }
        },

        loadProducts: _.debounce(function(query) {
            let options = {
                params: {
                    query: query,
                    limit: this.multiselect_query_limit,
                },
            };

            this.ajaxProductLoading = true;
            this.$http.get(this.api_item_select, options).then(response => {
                this.items = response.data.data;
                this.ajaxProductLoading = false;
            });
        }, 500),

        loadTags: _.debounce(function(query) {
            let options = {
                params: {
                    query: query,
                    limit: this.multiselect_query_limit,
                },
            };

            this.ajaxTagLoading = true;
            this.$http.get(this.api_tag_select, options).then(response => {
                this.tags = response.data.data.filter(
                    tag => tag.id != this.tag.id,
                );
                this.ajaxTagLoading = false;
            });
        }, 500),

        show_product_list() {
            this.$emit('showupProduct', this.tag);
        },

        tagOptionsLabel({ name, parent }) {
            return `${name} ${parent ? `(Parent Tag: ${parent.name})` : ''}`;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/tag/vuetabletag_form.vue